import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";

// Material  React Context Provider
import { MaterialUIControllerProvider } from "context";

// Import your AuthContextProvider
import { AuthContextProvider } from "context/AuthContext";

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <AuthContextProvider>
        {" "}
        <App />
      </AuthContextProvider>
    </MaterialUIControllerProvider>
  </BrowserRouter>
);
